import React, { useState, useEffect, Fragment } from 'react';
import { useHistory } from "react-router-dom";
import UserMenu from './UserMenu';
import Tools from './Tools';
import Sidebar from './Sidebar';
import './css/Home.css';

import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from 'react-modern-calendar-datepicker';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import TaskTreeFilter from './TaskTreeFilter';
import CallStatusFilter from './CallStatusFilter';
import Alert from './Alert';
import { set } from 'lodash';

const NewCampaign = (props) => {
    const [sessionData, setSessionData] = useState({}); 
    const [error, setError] = useState(null);
    const history = useHistory();
    const [selectedDay, setSelectedDay] = useState(null);
    const [data, setData] = useState({phoneIndex:"1"});
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loadingDetails, setLoadingDetails] = useState(false);
    const [loadingCreateCampaign, setLoadingCreateCampaign] = useState(false);
    const [resultFilter, setResultFilter] = useState(null);
    const [assigning, setAssigning] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [resetForm, setResetForm] = useState(false);
    const [reportDownloadPopOver, setReportDownloadPopOver] = useState(null);


    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const setTaskType = (taskType) => {
        setData({ ...data, ['taskType']: taskType });
    }

    const setContactType = (contactType) => {
        //setData({ ...data, ['contactType']: contactType });
        let changes={['contactType']: contactType, taskType:undefined};
        setData( {...data, ...changes});
    }

    const setCallStatusFilter = (callStatusFilter) => {
        setData({ ...data, ['callStatusFilter']: callStatusFilter });
    }

    const setIncludeAbandonmentsFilter = (includeAbandonmentsFilter) => {
        setData({ ...data, ['includeAbandonmentsFilter']: includeAbandonmentsFilter });
    }

    const handleChangeCompany = (event) => {
        getAssignments(event.target.value);
        let changes={
            [event.target.name]: event.target.value, 
            assignmentId:undefined} //remove assignmentId
        setData( {...data, ...changes});
    }

    const handleCheck = (event) => {
        setData({ ...data, [event.target.name]: event.target.checked })
    };


    useEffect(() => {
        if (!sessionStorage.getItem('sessionData')) {
            history.push('/login');
        } else {
            
            //get companies
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/companies`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                params: {}
            };
            axios(options).then(response => {
                setCompanies(response.data);
            })
            .catch(function (error) {
                console.log("Error:", error.message);
                setError(error.message);
            });
        }

        console.log('🐞DEBUG llegue');
    }, []);


    useEffect(() => {
        if(data.filterCampaign==='NO'){
            let changes={callStatusFilter: undefined, contactType:undefined, taskType:undefined};
            setData( {...data, ...changes});
        }
    }, [data.filterCampaign]);

    const getAssignments = (companyId)=>{
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/assignments`, {
            params: { companyId: companyId}
        })
        .then(function (response) {
            setAssignments(response.data);
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            setError(error.message);
            //setLoading(false);
        });
    }

    const getCampaigns = (event)=>{
        let assignmentId = event.target.value;
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/campaignsAssignment`, {
            params: { assignmentId: assignmentId}
        })
        .then(function (response) {
            setCampaigns(response.data);
            //setLoading(false);
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            setError(error.message);
            //setLoading(false);
        });
    }


    const getCustomLocale = () => {
        const athenaCustomLocale = {
            months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',],

            // week days by order
            weekDays: [
                { name: 'Lunes', short: 'L', },
                { name: 'Martes', short: 'M', },
                { name: 'Miércoles', short: 'M', },
                { name: 'Jueves', short: 'J', },
                { name: 'Viernes', short: 'V', },
                { name: 'Sábado', short: 'S', isWeekend: true, },
                { name: 'Domingo', short: 'D', isWeekend: true, },
            ],

            // just play around with this number between 0 and 6
            weekStartingIndex: 6,


            // return a { year: number, month: number, day: number } object
            getToday(gregorainTodayObject) {
                return gregorainTodayObject;
            },

            // return a native JavaScript date here
            toNativeDate(date) {
                return new Date(date.year, date.month - 1, date.day);
            },

            // return a number for date's month length
            getMonthLength(date) {
                return new Date(date.year, date.month, 0).getDate();
            },

            // return a transformed digit to your locale
            transformDigit(digit) {
                return digit;
            },

            // texts in the date picker
            nextMonth: 'Próximo mes',
            previousMonth: 'Mes anterior',
            openMonthSelector: 'Selector de mes',
            openYearSelector: 'Selector de año',
            closeMonthSelector: 'Cerrar selector de mes',
            closeYearSelector: 'Cerrar selector de año',
            defaultPlaceholder: 'Seleccionar...',

            // for input range value
            from: 'De',
            to: 'a',


            // used for input value when multi dates are selected
            digitSeparator: ',',

            // if your provide -2 for example, year will be 2 digited
            yearLetterSkip: 0,

            // is your language rtl or ltr?
            isRtl: false,
        }

        return athenaCustomLocale;
    }

    const logout = () => {
        alert('Se sesión de usuario ha finalizado, es necesario que vuelva a iniciar sesión.');
        sessionStorage.clear();
        history.push('/login');
    }

    const buildFilter=()=>{
        let serviceParams = {};
        if (data.filterAmmountCondition && data.filterAmmountCondition !== 'NO') {
            serviceParams.filterAmmountCondition = data.filterAmmountCondition;
        }
        if (data.filterAmmount && data.filterAmmount !== '') {
            serviceParams.filterAmmount = data.filterAmmount;
        }

        if (data.filterAmmountCondition && data.filterAmmountCondition === 'RG' && data.filterAmmount2 && data.filterAmmount2 !== '') {
            serviceParams.filterAmmount2 = data.filterAmmount2;
        }

        if (data.filterCampaign && data.filterCampaign !== 'NO') {
            serviceParams.filterCampaign = data.filterCampaign;
        }

        if (data.filterTask && data.filterTask !== 'NO') {
            serviceParams.filterTask = data.filterTask;
        }

        if (data.contactType) { serviceParams.filterContactType = data.contactType; }
        if (data.taskType) { serviceParams.filterTaskType = data.taskType; }

        
        if (data.callStatusFilter) { serviceParams.callStatusFilter = data.callStatusFilter; }


        if (data.fileWithClientIds) {
            serviceParams.filterFileWithClientIds = data.fileWithClientIds;
        }

        if (data.fileType) {
            serviceParams.fileType = data.fileType;
        }

        if (data.phoneIndex && data.fileType !== 'rutMorePhone') {
            serviceParams.phoneIndex = data.phoneIndex;
        }

        serviceParams.filterCompanyId = data.company;
        serviceParams.filterAssignmentId = data.assignmentId;
        serviceParams.includeAbandonmentsFilter = data.includeAbandonmentsFilter;

        serviceParams.excludeDC = data.excludeDC;


        return serviceParams;
    }

    
    const applyFilter = () => {
        let serviceParams = buildFilter();
        serviceParams.resultType = 'totals';

        //console.log('🐞DEBUG serviceParams:', serviceParams);
        setLoadingFilter(true);
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/clientsFilter`, {
            params: serviceParams
        })
        .then(function (response) {
            setLoadingFilter(false);
            if (response.data) {
                setResultFilter(response.data);
            } else {
                setResultFilter({ "count": 0, "totals": 0, "countDocs":0 });
            }
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            setLoadingFilter(false);
        });
    }

    const resetFilter=()=>{
        setData({});
        setAssignments([]);
        setCampaigns([]);        
        setResultFilter(null);
        setAssigning(false);
        setResetForm(!resetForm);
    }


    const downloadDetails = () => {
        let serviceParams = buildFilter();
        serviceParams.resultType = 'details';

        setLoadingDetails(true);
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/clientsDetails`, {
            params: serviceParams
        })
        .then(function (response) {
            setLoadingDetails(false);

            // let csv = 'data:text/csv;charset=utf-8,' + response.data;
            // let csvData = encodeURI(csv);
            // window.open(csvData);

            setReportDownloadPopOver(response.data.file);
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            setLoadingDetails(false);
        });
    }


    
    const createCampaignAndAssignExtract = () => {
        let serviceParams = buildFilter();
        serviceParams.campaignType=data.campaignType;
        serviceParams.resultType='details';
        serviceParams.campaignName = data.campaignName;
        serviceParams.count = resultFilter.count;
        serviceParams.totals = resultFilter.totals;
        serviceParams.excludeDC = data.excludeDC;
        serviceParams.callPrefix = data.callPrefix;

        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/campaign`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: serviceParams
        };

        setLoadingCreateCampaign(true);

        axios(options).then(response => {
            
            if (response.status === 200) {
                if(response.data.error){
                    setError(response.data.error);
                    setLoadingCreateCampaign(false);
                } else {
                    setError(null);
                    setLoadingCreateCampaign(false);
                    toast.success('Una nueva campaña ha sido generada para el filtro aplicado.', {
                        duration: 5000,
                        style: {
                            borderRadius: '10px',
                            background: '#333',
                            color: '#fff',
                        },
                    });
                }
            }
        })
        .catch(function (error) {
            if (error.response) {
                if(error.response.data ==='Unauthorized'){
                    logout();
                }
            }
        });

    }

      
    const uploadFile = (e) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        let formData = new FormData();
        formData.append("file", e.target.files[0]);

        axios.post(`${process.env.REACT_APP_URI_API_CRM}/uploadFileOfClientIds`, formData, {
            headers: { "Content-Type": "multipart/form-data", 'Authorization': currentSessionData.token },
        }).then((response) => {
            //setData({ ...data, ['fileWithClientIds']: response.data.fileOnServer })
            setData({ ...data, ['fileWithClientIds']: response.data.fileOnServer, ['fileType']: 'rut' });
        }).catch((error) => {
        console.log('🐞DEBUG error:',error);
        });
    };

    const clearFileInputSelection =()=>{
        document.querySelector('input[type=file]').value=null;
        //setData({ ...data, ['fileWithClientIds']: undefined });
        setData({ ...data, ['fileWithClientIds']: undefined, ['fileType']: undefined });
    }
    

    return (
        <div className="mainWrapper">
            <Toaster position="bottom-right" reverseOrder={false} />
            <Sidebar key={props.inboundConnectedQueues} softphoneConnectionStatus={props.softphoneConnectionStatus}/>
            <div className="main">
                {error?(
                    <Alert className="error mt20">Error: {error}.</Alert>
                ):null}

                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1>Nueva Campaña</h1>
                        <span className="upper">Seleccione el filtro para generar un subconjunto de datos para la campaña.</span>
                    </div>
                    <div className="flexWrapper"> 
                        {/* {sessionData.profile_desc === 'Supervisor' ? (
                            <NavMenu functionToRefreshParent={refreshCampaignsAndNotify}/>
                        ) : null} */}
                        <UserMenu profile={sessionData.profile_desc}/>
                    </div>
                </div>

                <div className="flexRow gap20">
                    <div className="flexCol">
                        <form className="export">
                            <div className="flexRow">
                                <div className="flexCol inputWrapper x4">
                                    <label className='required'>Empresa</label>
                                    <div className="selectWrapper">
                                        <select key={resetForm} name="company" onChange={handleChangeCompany} defaultValue={""}>
                                            <option value="" disabled hidden>seleccione ...</option>
                                            {companies.map(option =>
                                                <option key={option._id} value={option._id}>{option.name}</option>
                                            )}
                                        </select>
                                    </div>
                                </div>
                                <div className="flexCol inputWrapper x3">
                                    <label className='required'>Asignación</label>
                                    <div className="selectWrapper">
                                        <select key={data.company} name="assignmentId" defaultValue={""} onChange={(e) => {handleChange(e); getCampaigns(e)}}>
                                            <option value="" disabled hidden>seleccione ...</option>
                                            {assignments.map(option =>
                                                <option key={option._id} value={option._id}>{Tools.fdtCL(option.date) +' ('+option.name+')'}</option>
                                            )}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className={data.filterCampaign && data.filterCampaign!=='NO'?'filterWrapper active':'filterWrapper'}>
                                <div className="flexRow">
                                    <div className="flexCol inputWrapper x4">
                                        <label>Reciclar campaña</label>
                                        <div className="selectWrapper">
                                            <select key={resetForm} name="filterCampaign" onChange={handleChange}>
                                                <option value="NO">Ninguna</option>
                                                {campaigns.map((campaign, index) => {
                                                    return (
                                                        <option key={index} value={campaign._id}>{campaign.name}</option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {data.filterCampaign && data.filterCampaign!=='NO'?(
                                    <Fragment>
                                        <CallStatusFilter setCallStatusFilter={setCallStatusFilter}/>
                                        
                                        {data.company?(
                                            <TaskTreeFilter key={data.company} companyId={Number(data.company)} setTaskType={setTaskType} setContactType={setContactType}/>
                                        ):null}
                                    </Fragment>
                                ):null}
                            </div>

                            <div className="flexRow">
                                <div className="flexCol inputWrapper">
                                    <label>Monto deuda</label>
                                    <div className="selectWrapper">
                                        <select key={resetForm} name="filterAmmountCondition" onChange={handleChange}>
                                            <option value="NO">Cualquiera</option>
                                            <option value="GT">Superior a ...</option>
                                            <option value="LT">Inferior a ...</option>
                                            <option value="EQ">Igual a</option>
                                            <option value="RG">Valores entre</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="flexCol inputWrapper">
                                    <label>monto</label>
                                    <input type="text" key={resetForm} name="filterAmmount" onChange={handleChange} placeholder="monto" />
                                </div>
                                {data.filterAmmountCondition==='RG'?(
                                <div className="flexCol inputWrapper">
                                    <label>monto</label>
                                    <input type="text" key={resetForm} name="filterAmmount2" onChange={handleChange} placeholder="monto" />
                                </div>
                                ):null}
                            </div>


                            <div className="flexRow">
                                <div className="flexCol inputWrapper fileInput x4">
                                    {data.fileWithClientIds?(<button className="clear" onClick={clearFileInputSelection}></button>):null}
                                    <label>Según archivo de ruts</label>
                                    <input type="file" key={resetForm} onChange={uploadFile} accept =".txt"/>
                                </div>
                                {data.fileWithClientIds?(
                                    <div className="flexCol inputWrapper radio x2">
                                        <label>Tipo archivo</label>
                                        <div className='flex'>
                                            <label> 
                                                <input type="radio" name="fileType" value="rut" onChange={handleChange} defaultChecked={true}/>Rut
                                            </label>
                                            <label> 
                                                <input type="radio" name="fileType" value="rutMorePhone" onChange={handleChange} />Rut + teléfono
                                            </label>
                                        </div>
                                    </div>
                                ):null}
                            </div>

                            <div className="flexRow">
                                
                                {data.fileType!=="rutMorePhone" ? (
                                    <div className="flexCol inputWrapper radio sp2 x5">
                                        <label>Índice teléfono</label>
                                        <div className='flex'>
                                            <label><input type="radio" name="phoneIndex" value="1" onChange={handleChange} defaultChecked={true} />1</label>
                                            <label><input type="radio" name="phoneIndex" value="2" onChange={handleChange}/>2</label>
                                            <label><input type="radio" name="phoneIndex" value="3" onChange={handleChange}/>3</label>
                                            <label><input type="radio" name="phoneIndex" value="4" onChange={handleChange}/>4</label>
                                            <label><input type="radio" name="phoneIndex" value="5" onChange={handleChange}/>5</label>
                                            <label><input type="radio" name="phoneIndex" value="6" onChange={handleChange}/>6</label>
                                            <label><input type="radio" name="phoneIndex" value="7" onChange={handleChange}/>7</label>
                                            <label><input type="radio" name="phoneIndex" value="8" onChange={handleChange}/>8</label>
                                            <label><input type="radio" name="phoneIndex" value="9" onChange={handleChange}/>9</label>
                                            <label><input type="radio" name="phoneIndex" value="10" onChange={handleChange}/>10</label>
                                        </div>
                                    </div>
                                ) : null}

                            </div>



                            <div className="flexRow">
                                <div className="flexCol inputWrapper x3">
                                    <label>Excluir Contacto Directo (semana)</label>
                                    <input name="excludeDC" type="checkbox" onChange={handleCheck} /> 
                                </div>
                            </div>
                            
                        </form>
                        <button className={(loadingFilter) ? 'default mainAction loading' : 'default mainAction'} onClick={applyFilter}><i className='search'></i>Aplicar filtro</button>
                        {Object.keys(data).length > 0?(
                            <button className='default outline ml10' onClick={resetFilter}>Resetear filtro</button>
                        ):null}
                    </div>
                    <div className="flexCol">
                        {resultFilter ? (
                            <div className={loadingFilter ? 'processWrapper loading' : 'processWrapper'}>
                                <div className="resultsDetails">
                                    <b>Resumen</b><br /><br />
                                    <div className="lineDetails"><span>Clientes aplican</span><span>{Tools.fmtClNumber(resultFilter.count)}</span></div>
                                    <div className="lineDetails"><span>Documentos</span><span>{Tools.fmtClNumber(resultFilter.countDocs)}</span></div>
                                    <div className="lineDetails"><span>Montos filtro</span><span>{Tools.fmtClAmmount(resultFilter.totals)}</span></div>
                                    <hr/>
                                    <div className="flexRow cg10">
                                        <div>
                                            <button className={(loadingDetails) ? 'default otherAction outline loading' : 'default otherAction outline'} onClick={downloadDetails}>Exportar resultados</button>
                                            {reportDownloadPopOver?(
                                                <div className='popoverDownload'>
                                                    <div className="closeDiv" onClick={() => setReportDownloadPopOver(null)}></div>
                                                    Haga click aquí para descargar el reporte:<br/>
                                                    <a href={reportDownloadPopOver} target='_Blank'>{reportDownloadPopOver}</a>
                                                </div>
                                            ) : null}
                                        </div> 
                                        <button className="default mainAction" onClick={() => setAssigning(true)}>Asignar a campaña</button>
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        {assigning ? (
                            <div className="assign">
                                <div className="inputWrapper x3">
                                    <label>Nombre campaña</label>
                                    <input type="text" name="campaignName" maxLength="50" onChange={handleChange} />
                                </div>
                                <div className="flexCol inputWrapper">
                                    <label className='required'>Tipo campaña</label>
                                    <div className="selectWrapper">
                                    <select name="campaignType" onChange={handleChange} defaultValue={""}>
                                        <option value="" disabled hidden>seleccione ...</option>
                                        <option value="ASSISTED">Telefónica Asistida</option>
                                        <option value="PROGRESSIVE">Telefónica Progresiva</option>
                                        <option value="VOICEROBOT">Robot Voz</option>
                                        <option disabled value="SMS">SMS</option>
                                        <option disabled value="MAILING">Mailing</option>
                                    </select>
                                    </div>
                                </div>   

                                <div className="flexCol inputWrapper">
                                    <label className='required'>Prefijo llamada</label>
                                    <div className="selectWrapper">
                                        <select name="callPrefix" onChange={handleChange} defaultValue={""}>
                                        <option value="" disabled hidden>seleccione ...</option>
                                        <option value="600">600</option>
                                        <option value="569">569</option>
                                    </select>
                                    </div>
                                </div>  

                                <button disabled={data.campaignName===undefined || data.campaignType===undefined} className={loadingCreateCampaign ? 'default collapsed loading' : 'default collapsed'} onClick={createCampaignAndAssignExtract}>Crear campaña</button>
                            </div>
                        ) : null}

                    </div>
                </div>

                
                <p className='debug'>Data:{JSON.stringify(data)}</p>
            
            </div>
        </div>
    );
}

export default NewCampaign;